//@ts-nocheck
import React, { lazy, Suspense } from "react";
import UnKnownError from "./component/unKnown";

interface PropsType {
  message?: string;
  code: "404" | "500" | "accessDenied" | "550" | "unKnown";
}
const Map = {
  404: "404",
  500: "500",
  550: "550",
  "-100": "500",
  unKnown: "unKnown",
};
export default function ErrorComponent(props: PropsType) {
  const Component = lazy(() =>
    import(`./component/${Map[props?.code]}`).catch(() => ({
      default: () => (
        <div className="mt-5">
          <UnKnownError {...props} />
        </div>
      ),
    }))
  );

  return (
    <Suspense fallback={<></>}>
      <Component {...props} />
    </Suspense>
  );
}
